import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { AuthService } from "../../drive-adapter/user-service/auth.service";
import { catchError } from 'rxjs/operators';
import { buildCreditCardValidationError, payloadBlamesCreditCard } from "src/app/domain/models/funnel/credit-card-validation-error";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private accountService: AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            let errorMessage: any = "An internal error has occurred, please try again";
            switch(err.status) {
                case 400:
                    // registration-api reports a funnel outcome as { result: "<FunnelCodeResponse>" },
                    // and answers 400 for the blacklist codes (GlobalExceptionFilter) while other
                    // funnel rejections still answer 404. The funnel components compare the thrown
                    // value against FunnelCodeResponse to decide whether to redirect to the Duplicate
                    // User page, so that raw code has to survive here — replacing it with a readable
                    // message silently turns the redirect into "An internal error has occurred".
                    if(err?.error?.result) {
                        errorMessage = err.error.result;
                    }
                    else if(typeof err?.error?.errors! == "object" && err?.error?.errors) {
                        errorMessage = "";
                        Object.values(err.error.errors).forEach((message: any) => {
                            // Parenthesised on purpose: `+` binds tighter than `??`, so the
                            // original `message ?? "" + "<br>"` meant `message ?? "<br>"` —
                            // a present message never got a separator, and an absent one
                            // contributed a stray line break.
                            errorMessage += (message ?? "") + "<br>";
                        });
                        // A card the API refuses arrives as model validation on a credit card
                        // field, with no funnel code to switch on. Encode it so the funnel layer
                        // counts the attempt instead of treating the prose as a code — the text
                        // itself survives inside the sentinel and is what the user is shown.
                        if(payloadBlamesCreditCard(err.error.errors)) {
                            errorMessage = buildCreditCardValidationError(errorMessage);
                        }
                    }
                    break;
                case 401 || 403:
                    this.accountService.Logout();
                    break;
                case 404:
                    errorMessage = (err && err.error)? (err.error.result)? err.error.result:
                        (err.error.errors)? err.error.errors[0].detail: errorMessage: "";
                    break;
            }
            return throwError(errorMessage);
        }))
    }
}